import styled from 'styled-components';
import { getColor, getSizeBy } from '../../../src/styled/utils';
import { Subtitle1Styles, CaptionStyles, Overline } from '../typography';
export const LabelStyled = styled.div `
  ${({ $type }) => ($type == 'label' ? Subtitle1Styles : CaptionStyles)}
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  height: ${getSizeBy(4)};
  margin: 0;
  padding: ${({ $marker, $withMarker, $contrast, $type, theme }) => {
    const hasNoMarker = !$withMarker || $contrast || $type === 'tag';
    if (hasNoMarker)
        return getSizeBy(1);
    const verticalPadding = getSizeBy(1)(theme);
    let leftPad = getSizeBy(3.5)(theme);
    let rightPad = getSizeBy(1.5)(theme);
    if (($marker === null || $marker === void 0 ? void 0 : $marker.horizontal) === 'right') {
        leftPad = getSizeBy(1.5)(theme);
        rightPad = getSizeBy(3.5)(theme);
    }
    return verticalPadding + ' ' + rightPad + ' ' + verticalPadding + ' ' + leftPad;
}};
  color: ${({ $contrast, $type, theme }) => {
    const isHighContrast = $contrast && $type !== 'tag';
    if (isHighContrast)
        return getColor('surface', 'highEmphasis')({ theme });
    return getColor('onSurface', 'highEmphasis')({ theme });
}};
  font-size: ${({ $type }) => {
    return $type === 'tag' ? getSizeBy(2.75) : getSizeBy(2.5);
}};
  line-height: ${({ $type }) => {
    return $type === 'label' ? getSizeBy(3) : '';
}};
  letter-spacing: ${getSizeBy(0.07)};
  background-color: ${({ $color, $contrast, $type, theme }) => {
    const isDarkTheme = theme.type === 'Dark';
    let color = $color !== null && $color !== void 0 ? $color : 'onBackground';
    let shade = $contrast ? 'highEmphasis' : 'lowEmphasis';
    if ($type === 'tag') {
        color = 'onBackground';
        shade = 'lowEmphasis';
    }
    else if ((isDarkTheme || $contrast) && $color === 'onBackground') {
        color = 'onSurface';
        shade = 'lowEmphasis';
    }
    return getColor(color, shade)({ theme });
}};
  border: ${({ $type, theme }) => {
    if ($type !== 'tag')
        return '';
    return `solid 1px ${getColor('onBackground', 'highEmphasis')({ theme })}`;
}};
  border-radius: ${getSizeBy(1)};
  ${Overline}
`;
